module.exports = __webpack_public_path__ + "assets/img/sample_student_profile.e1c82f06.png";